import { FETCH_PLANOGRAM_TEMPLATE_LIST } from "../../constants/action.constants";

const initialState = {
  list: [],
  others: {
    total: 0,
    offset: 0,
    limit: 20,
  },
};

const planogramTemplateList = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PLANOGRAM_TEMPLATE_LIST:
      return { list: action.payload, others: action.others };
    default:
      return state;
  }
};

export default planogramTemplateList;
